/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_End_Time_SecondsInputs */



/**
* | output |
* | --- |
* | "End Time (Seconds)" |
*
* @param {Markers_Export_End_Time_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_end_time_seconds = /** @type {((inputs?: Markers_Export_End_Time_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_End_Time_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heure de fin (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo finale (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время окончания (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de finalización (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo final (em segundos)")
	return /** @type {LocalizedString} */ ("End Time (Seconds)")
});